import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { AuthenticationService } from '../../_services';
import { CloseOverlayService } from '../../_services/closeOverlay.service';
import { PaymentsStore } from '../../_services/store';

@Component({
  selector: 'app-payment-fail',
  templateUrl: './payment-fail.page.html',
  styleUrls: ['./payment-fail.page.scss'],
})
export class PaymentFailPage implements OnInit {
  subscription: any;

  constructor(
    private router: Router,
    private platform: Platform,
    private auth: AuthenticationService,
    private paymentsStore: PaymentsStore,
    private modalController: ModalController,
    private closeOverlayService: CloseOverlayService
  ) { }

  tryAgain() {
    this.paymentsStore.removeAmount();
    this.closeOverlayService.trigger();
    this.modalController.dismiss();
    if (this.auth.currentUserValue) {
      this.router.navigate(['/new-payment']);
    } else {
      this.router.navigate(['/demo/payment']);
    }
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      console.log('Don\'t go back');
    });
  }

  ionViewDidLeave() {
    console.log('Left payment fail modal');
    this.subscription.unsubscribe();
  }

  ngOnInit() {
  }

}
